<template>
  <div>
    <div class="container col-md-8 offset-md-2 mt-5">
      <div class="card p-3 mb-3 card-lg shadow steps-card">
        <div class="container text-black">
          <div class="text-left my-3 font-25px steps-title">
            {{ $t("the_team") }}
          </div>
          <div class="mb-40" v-show="show_team_list">
            <div class="col-12 row">
              <div v-for="(member, id) in members" class="p-2" :key="id">
                <div class="card bg-white rounded-0 text-black p-2 member_card">
                  <div class="container member_name font-lato-bold font-weight-bold">
                    <div class="row p-3">
                      <div>
                        <div>
                          {{ member.first_name + " " + member.last_name }}
                        </div>
                        <small v-show="member.project_master" class="member_master font-lato-italic">Capofila</small>
                      </div>
                      <div class="pl-10">
                        <button @click="editMember(member, id)" class="member_button mx-1">
                          <i class="tio tio-edit member_icon"></i>
                        </button>
                        <button @click="removeModal(member)" class="member_button">
                          <i class="tio tio-delete member_icon"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <team class="hover-mouse-pointer mb-5" @click.native="addNewTeamMember()"></team>

            <div class="text-left my-3 font-25px steps-title">
              {{ $t("incubator") }}
            </div>
            <div class="form-row">
              <div class="col-lg-12 form-group">
                <select
                  class="custom-select form-control"
                  :class="{
                    'is-invalid': $v.project.business_incubator.$error,
                  }"
                  @focus="showHideLabel('business_incubator')"
                  @blur="showHideLabel('business_incubator')"
                  v-model="$v.project.business_incubator.$model"
                  required
                >
                  <option :value="null" selected disabled class="custom-select-placeholder">{{ $t("which_business_incubator") }} *</option>
                  <option v-for="option in businessIncubatorSelect.options" :value="option.option_ita" :key="option.option_ita">
                    {{ option.option }}
                  </option>
                </select>
                <small v-show="project.business_incubator" id="business_incubator_label" style="display: block" class="mt-2">
                  {{ $t("which_business_incubator") }}
                  *</small
                >
              </div>
            </div>
          </div>

          <!-- Start card content -->
          <div v-show="!show_team_list">
            <div class="row">
              <div class="col-lg-6 form-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.first_name.$error,
                  }"
                  :placeholder="$t('first_name') + ' *'"
                  @focus="showHideLabel('first_name')"
                  @blur="showHideLabel('first_name')"
                  v-model.trim="$v.selectedMember.first_name.$model"
                />
                <small id="first_name_label" style="display: none" class="mt-2">{{ $t("first_name") + "*" }}</small>
              </div>
              <div class="col-lg-6 form-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.last_name.$error,
                  }"
                  :placeholder="$t('last_name') + ' *'"
                  @focus="showHideLabel('last_name')"
                  @blur="showHideLabel('last_name')"
                  v-model.trim="$v.selectedMember.last_name.$model"
                  required
                />
                <small id="last_name_label" style="display: none" class="mt-2">{{ $t("last_name") }} *</small>
              </div>
            </div>

            <div class="form-group">
              <custom-checkbox input-id="project_master" v-model="selectedMember.project_master" :disabled="projectHasMaster()">
                {{ $t("project_master") }}
                <i class="tio-info color-gray" data-container="body" data-toggle="popover" data-trigger="hover" id="popover" data-placement="right" :data-content="$t('project_master_info')"></i>
              </custom-checkbox>
            </div>

            <div class="form-row">
              <div class="col-lg-6 form-group">
                <v-select
                  :class="{
                    'is-invalid': $v.selectedMember.gender.$error,
                  }"
                  :options="genderSelect.options.map((o) => o.option)"
                  v-model.trim="$v.selectedMember.gender.$model"
                  :clearable="false"
                  :placeholder="`${$t('gender')} *`"
                  @focus="showHideLabel('gender')"
                  @blur="showHideLabel('gender')"
                ></v-select>
                <small id="gender_label" style="display: none" class="mt-2">Sesso *</small>
              </div>
              <div class="col-lg-6 form-group">
                <!-- <datepicker
                                    :class="{
                                        'is-invalid':
                                            $v.selectedMember.born_on.$error,
                                    }"
                                    :placeholder="$t('date_of_birth') + ' *'"
                                    onfocus="(this.type='date')"
                                    id="birthday"
                                    @focus="showHideLabel('born_on')"
                                    @blur="showHideLabel('born_on')"
                                    :language="it"
                                    :bootstrap-styling="true"
                                    :monday-first="true"
                                    v-model.trim="
                                        $v.selectedMember.born_on.$model
                                    "
                                ></datepicker> -->
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.born_on.$error,
                  }"
                  :placeholder="$t('date_of_birth') + ' *'"
                  onfocus="(this.type='date')"
                  id="birthday"
                  @focus="showHideLabel('born_on')"
                  @blur="showHideLabel('born_on')"
                  v-model.trim="$v.selectedMember.born_on.$model"
                />
                <small id="born_on_label" style="display: none" class="mt-2">{{ $t("date_of_birth") }} *</small>
              </div>
            </div>

            <div class="form-row">
              <div class="col-lg-6 form-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.born_in.$error,
                  }"
                  :placeholder="$t('birth_place') + ' *'"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Luogo di nascita *'"
                  @focus="showHideLabel('born_in')"
                  @blur="showHideLabel('born_in')"
                  v-model.trim="$v.selectedMember.born_in.$model"
                  required
                />
                <small id="born_in_label" style="display: none" class="mt-2">{{ $t("birth_place") }} *</small>
              </div>
              <div class="col-lg-6 form-group">
                <v-select
                  :class="{
                    'is-invalid': $v.selectedMember.residence_state.$error,
                  }"
                  :options="countriesSelect.map((c) => c.name)"
                  v-model.trim="$v.selectedMember.residence_state.$model"
                  :clearable="false"
                  :placeholder="`${$t('residence_state')} *`"
                  @focus="showHideLabel('residence_state')"
                  @blur="showHideLabel('residence_state')"
                  @input="selectedMember.residence_province = null"
                ></v-select>
                <small id="residence_state_label" style="display: none" class="mt-2"> {{ $t("residence_state") }} *</small>
              </div>
            </div>

            <div class="form-row">
              <div class="col-lg-6 form-group">
                <v-select
                  v-if="selectedMember.residence_state == 'Italia'"
                  :class="{
                    'is-invalid': $v.selectedMember.residence_province.$error,
                  }"
                  :options="provincesSelect.map((p) => p.long_name)"
                  v-model.trim="$v.selectedMember.residence_province.$model"
                  :clearable="false"
                  :placeholder="`${$t('residence_province')} *`"
                  @focus="showHideLabel('residence_province')"
                  @blur="showHideLabel('residence_province')"
                ></v-select>
                <input
                  v-else
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.residence_province.$error,
                  }"
                  :placeholder="$t('residence_province') + ' *'"
                  @focus="showHideLabel('residence_province')"
                  @blur="showHideLabel('residence_province')"
                  v-model.trim="$v.selectedMember.residence_province.$model"
                />
                <small id="residence_province_label" style="display: none" class="mt-2">{{ $t("residence_province") }} *</small>
              </div>
              <div class="col-lg-6 form-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.residence_city.$error,
                  }"
                  :placeholder="$t('residence_city') + ' *'"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Città di residenza *'"
                  @focus="showHideLabel('residence_city')"
                  @blur="showHideLabel('residence_city')"
                  v-model.trim="$v.selectedMember.residence_city.$model"
                  required
                />
                <small id="residence_city_label" style="display: none" class="mt-2">{{ $t("residence_city") }} *</small>
              </div>
            </div>

            <div class="form-group" @click="hasDomicile()">
              <div v-show="!domicile">
                <i class="tio-add-circle" style="color: #f2b12d; cursor: pointer" id="domicile"></i>
                <label class="font-16px" style="cursor: pointer" for="domicile"> {{ $t("add_domicile") }}</label>
              </div>
              <div v-show="domicile" style="cursor: pointer">
                <i class="tio-remove-circle" style="color: #f2542d; cursor: pointer" id="remove_domicile"></i>
                <label class="font-16px" style="cursor: pointer" for="domicile">{{ $t("domicile_same_as_residence") }}</label>
              </div>
            </div>

            <transition name="fade">
              <div v-show="domicile">
                <div class="form-row">
                  <div class="col-lg-12 form-group">
                    <v-select
                      :class="{
                        'is-invalid': $v.selectedMember.domicile_state.$error,
                      }"
                      :options="countriesSelect.map((c) => c.name)"
                      v-model.trim="$v.selectedMember.domicile_state.$model"
                      :clearable="false"
                      :placeholder="`${$t('domicile_state')} *`"
                      @focus="showHideLabel('domicile_state')"
                      @blur="showHideLabel('domicile_state')"
                      @input="selectedMember.domicile_province = null"
                    ></v-select>
                    <small id="domicile_state_label" style="display: none" class="mt-2">{{ $t("domicile_state") }} *</small>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-lg-6 form-group">
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': $v.selectedMember.domicile_city.$error,
                      }"
                      :placeholder="$t('domicile_city') + ' *'"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='Città di domicilio *'"
                      @focus="showHideLabel('domicile_city')"
                      @blur="showHideLabel('domicile_city')"
                      v-model.trim="$v.selectedMember.domicile_city.$model"
                      required
                    />
                    <small id="domicile_city_label" style="display: none" class="mt-2">{{ $t("domicile_city") }} *</small>
                  </div>
                  <div class="col-lg-6 form-group">
                    <v-select
                      v-if="selectedMember.domicile_state == 'Italia'"
                      :class="{
                        'is-invalid': $v.selectedMember.domicile_province.$error,
                      }"
                      :options="provincesSelect.map((p) => p.long_name)"
                      v-model.trim="$v.selectedMember.domicile_province.$model"
                      :clearable="false"
                      :placeholder="`${$t('domicile_province')} *`"
                      @focus="showHideLabel('domicile_province')"
                      @blur="showHideLabel('domicile_province')"
                    ></v-select>
                    <input
                      v-else
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': $v.selectedMember.domicile_province.$error,
                      }"
                      :placeholder="$t('domicile_province') + ' *'"
                      @focus="showHideLabel('domicile_province')"
                      @blur="showHideLabel('domicile_province')"
                      v-model.trim="$v.selectedMember.domicile_province.$model"
                    />
                    <small id="domicile_province_label" style="display: none" class="mt-2">{{ $t("domicile_province") }} *</small>
                  </div>
                </div>
              </div>
            </transition>

            <div class="form-row">
              <div class="col-lg-6 form-group">
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.phone.$error,
                  }"
                  :placeholder="$t('phone_number') + ' *'"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Recapito telefonico *'"
                  @focus="showHideLabel('phone')"
                  @blur="showHideLabel('phone')"
                  v-model.trim="$v.selectedMember.phone.$model"
                />
                <small id="phone_label" style="display: none" class="mt-2">{{ $t("phone_number") }} *</small>
              </div>
              <div class="col-lg-6 form-group">
                <input
                  type="email"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.email.$error,
                  }"
                  :placeholder="$t('email') + ' *'"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Indirizzo email *'"
                  @focus="showHideLabel('email')"
                  @blur="showHideLabel('email')"
                  v-model.trim="$v.selectedMember.email.$model"
                />
                <small id="email_label" style="display: none" class="mt-2">{{ $t("email") }} *</small>
              </div>
            </div>

            <div class="form-row">
              <div class="col-lg-6 form-group">
                <v-select
                  :class="{
                    'is-invalid': $v.selectedMember.studies.$error,
                  }"
                  :options="studiesSelect.options.map((s) => s.option)"
                  v-model.trim="$v.selectedMember.studies.$model"
                  :clearable="false"
                  :placeholder="`${$t('educational_qualification')} *`"
                  @focus="showHideLabel('studies')"
                  @blur="showHideLabel('studies')"
                ></v-select>
                <small id="studies_label" style="display: none" class="mt-2">{{ $t("educational_qualification") }} *</small>
              </div>
              <div class="col-lg-6 form-group">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('educational_specialization')"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Specializzazione'"
                  @focus="showHideLabel('specialization')"
                  @blur="showHideLabel('specialization')"
                  v-model.trim="$v.selectedMember.specialization.$model"
                />
                <small id="specialization_label" style="display: none" class="mt-2">{{ $t("educational_specialization") }}</small>
              </div>
            </div>

            <div class="form-row">
              <div class="col-lg-6 form-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedMember.current_occupation.$error,
                  }"
                  :placeholder="$t('current_occupation') + ' *'"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Occupazione attuale *'"
                  @focus="showHideLabel('current_occupation')"
                  @blur="showHideLabel('current_occupation')"
                  v-model.trim="$v.selectedMember.current_occupation.$model"
                />
                <small id="current_occupation_label" style="display: none" class="mt-2">{{ $t("current_occupation") }} *</small>
              </div>
            </div>

            <div
              class="form-row"
              :class="{
                'mb-5': updating_member,
                'mb-20': !updating_member,
              }"
            >
              <div class="col-lg-10 font-16px">{{ $t("last_five_years") }} *</div>
              <div class="col-lg-2 from-group">
                <input v-model="selectedMember.last_five_years" type="radio" name="radios" id="true_last_five" :value="1" :checked="selectedMember.last_five_years" class="radio-btn" />
                <label for="true_last_five" class="btn btn-checkbox mr-2">{{ $t("yes") }}</label>

                <input v-model="selectedMember.last_five_years" type="radio" name="radios" id="false_last_five" :value="0" :checked="!selectedMember.last_five_years" class="radio-btn" />
                <label for="false_last_five" class="btn btn-checkbox">{{ $t("no") }}</label>
              </div>
              <small v-if="$v.selectedMember.last_five_years.$error" class="text-danger">{{ $t("last_five_years_required") }}</small>
            </div>

            <div class="underline mb-20" v-show="updating_member">
              <u @click="removeModal()">{{ $t("remove_member") }}</u>
            </div>
          </div>
          <!-- End Card content-->
        </div>

        <!-- navigator  -->
        <div
          class="p-5 wizard_navigator custom-row justify-content-between justify-content-center text-white font-lato-regular fixed-bottom sticky-bottom-bar"
          data-offset="-60"
          style="background-color: #f2b12d"
        >
          <a v-show="member_position <= 0" :href="welcomeRoute" class="font-16px hover-mouse-pointer" style="color: #fff">
            <i class="tio-arrow-left-circle-outlined font-25px"></i>
            {{ $t("back") }}
          </a>
          <a href="#" style="color: white" v-show="member_position > 0" class="font-16px hover-mouse-pointer" @click="previous()">
            <i class="tio-arrow-left-circle-outlined font-25px"></i>
            {{ $t("back") }}
          </a>
          <a href="#" style="color: white" class="font-16px hover-mouse-pointer" @click="next()">
           {{ $t("forward") }}
            <i class="tio-arrow-right-circle-outlined font-25px"></i>
          </a>
        </div>
      </div>

      <div class="col-12 text-center mt-6 stick-up-bottom-element">
        <button v-on:click="saveForLater" class="btn btn-secondary">
          {{ $t("save_and_continue") }}
        </button>
      </div>
    </div>

    <div class="modal fade" id="remove_member_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $t("remove_member") }}
            </h5>
            <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
              <i class="tio-clear tio-lg"></i>
            </button>
          </div>
          <div class="modal-body">
            {{ $t("sure_to_remove_member") }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              {{ $t("cancel") }}
            </button>
            <button type="button" @click="removeMember()" class="btn btn-primary">
              {{ $t("confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- no master modal -->
    <div class="modal fade" id="no_master_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $t("no_master_modal_title") }}
            </h5>
            <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
              <i class="tio-clear tio-lg"></i>
            </button>
          </div>
          <div class="modal-body">
            {{ $t("no_master_modal_description") }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              {{ $t("understood") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { minLength, required, helpers, email } from "vuelidate/lib/validators";
import Team from "../first_phase/Team";
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
const requiredIfHasDomicile = (value) => (domicile ? helpers.req(value) : "");
const dateRule = helpers.regex("alpha", /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/);

export default {
  components: { Team, Datepicker },
  props: ["projectProp", "membersProp", "route", "deleteRoute", "welcomeRoute", "genderSelect", "studiesSelect", "countriesSelect", "provincesSelect", "businessIncubatorSelect"],
  data() {
    return {
      isSaving: false,
      it: it,
      domicile: false,
      project: {
        business_incubator: null,
      },
      members: [],
      updating_member: false,
      emptyForm: {},
      show_team_list: false,
      member_position: 0,
      selectedMember: {
        first_name: null,
        last_name: null,
        project_master: false,
        gender: null,
        born_on: null,
        born_in: null,
        residence_city: null,
        residence_province: null,
        residence_state: null,
        domicile_city: null,
        domicile_province: null,
        domicile_state: null,
        phone: null,
        email: null,
        studies: null,
        specialization: null,
        current_occupation: null,
        last_five_years: null,
      },
    };
  },
  mounted() {
    var self = this;

    this.project = { ...this.projectProp };
    if (!this.projectProp.business_incubator) this.project.business_incubator = null;
    this.members = this.membersProp;
    this.emptyForm = Object.assign({}, this.selectedMember);

    if (this.members.length !== 0) {
      this.show_team_list = true;
      this.member_position = this.members.length;

      this.members.forEach(function (member, index) {
        if (member.born_on.indexOf("T") > 0) {
            member.born_on = member.born_on.split("T")[0];
        }
      });

    }

    $("#project_master").on("click", function (event) {
      if (self.projectHasMaster()) {
        event.preventDefault();
        event.stopPropagation();

        $("#popover").popover();
      }
    });

    $("#datatableWithFilter").on("page.dt", function (p) {
      setTimeout(() => {
        $('[data-toggle="popover"]').popover();
      }, 500);
    });
  },
  validations() {
    return {
      project: {
        business_incubator: this.show_team_list ? { required } : {},
      },
      selectedMember: {
        first_name: { required, minLength: minLength(2) },
        last_name: { required, minLength: minLength(2) },
        gender: { required },
        born_on: { required, dateRule },
        born_in: { required },
        residence_city: { required },
        residence_province: { required },
        residence_state: { required },
        domicile_city: {
          /*requiredIfHasDomicile*/
        },
        domicile_province: {
          /*requiredIfHasDomicile*/
        },
        domicile_state: {
          /*requiredIfHasDomicile*/
        },
        phone: { required },
        email: { required, email },
        studies: { required },
        current_occupation: { required },
        specialization: {},
        last_five_years: { required },
      },
    };
  },
  methods: {
    saveForLater() {
      if (this.isSaving) return;
      this.isSaving = true;

      var self = this;

      this.$v.$touch();
      if (this.$v.$anyError && !this.show_team_list) return (this.isSaving = false);

      axios
        .post(this.route, {
          members: self.members,
          project: self.project,
          later: true,
        })
        .then((response) => {
          window.location.href = response.data.redirect;
        });
    },
    next() {
      if (this.isSaving) return;
      this.isSaving = true;
      var self = this;
      // If the team list is visible and user presses "next"
      if (this.show_team_list) {
        // check if there is not a master
       const noMaster = this.members.find((m) => m.project_master) == null;
        if (noMaster) {
          $("#no_master_modal").modal();
          return (this.isSaving = false);
        }

        this.$v.$touch();
        if (this.$v.project.$anyError) return (this.isSaving = false);

        axios
          .post(this.route, {
            members: self.members,
            project: self.project,
          })
          .then((response) => {
            window.location.href = response.data.redirect;
          });
      } else {
        this.$v.$touch();
        if (this.$v.$anyError) return (this.isSaving = false);
        this.storeMember();
        this.isSaving = false;
      }
    },
    previous() {
      // Hide team list
      this.show_team_list = false;

      if (this.getPreviousMember()) {
        Object.assign(this.selectedMember, this.getPreviousMember());

        $("#birthday").attr("type", "date");
        this.selectedMember.born_on = this.selectedMember.born_on.split("T")[0];
        $("#birthday").val(this.selectedMember.born_on);

        if (this.selectedMember.domicile_city) {
          this.domicile = true;
        } else {
          this.domicile = false;
        }

        this.member_position--;
      }

      this.updating_member = true;
    },
    getPreviousMember() {
      let member = this.members[this.member_position - 1];
      return member;
    },
    storeMember() {
      if (this.updating_member) {
        if (!this.members[this.member_position].hasOwnProperty("id")) {
          delete this.selectedMember["id"];
          delete this.selectedMember["created_at"];
          delete this.selectedMember["updated_at"];
        }

        Object.assign(this.members[this.member_position], this.selectedMember);

        this.member_position++;

        if (this.member_position === this.members.length) {
          this.show_team_list = true;
          this.updating_member = false;

          return;
        } else {
          Object.assign(this.selectedMember, this.members[this.member_position]);

          if (this.selectedMember.domicile_city) {
            this.domicile = true;
          } else {
            this.domicile = false;
          }
        }
      } else {
        let member = {};

        Object.assign(member, this.selectedMember);
        this.members.push(member);

        this.resetForm();
        this.$v.$reset();
        this.hideLabels();
        this.member_position++;
        this.show_team_list = true;
      }
    },
    addNewTeamMember() {
      this.show_team_list = false;
      this.resetForm();
      this.$v.$reset();
      this.hideLabels();
    },
    resetForm() {
      if (this.selectedMember.hasOwnProperty("id")) {
        delete this.selectedMember["id"];
        delete this.selectedMember["created_at"];
        delete this.selectedMember["updated_at"];
      }

      Object.assign(this.selectedMember, this.emptyForm);
    },

    hasDomicile() {
      this.domicile = !this.domicile;
      this.$v.selectedMember.domicile_province.$reset();
      this.$v.selectedMember.domicile_city.$reset();
      this.$v.selectedMember.domicile_state.$reset();
    },
    showHideLabel(label) {
      var x = document.getElementById(label + "_label");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        var my_label = "this.selectedMember." + label;

        if (!eval(my_label)) x.style.display = "none";
      }
    },
    hideLabels() {
      let labels = document.querySelectorAll('[id$="_label"]');
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        label.style.display = "none";
      }
    },
    editMember(member, position) {
        this.show_team_list = false;
        member.born_on = member.born_on.split("T")[0];
        $("#birthday").attr("type", "date");
        $("#birthday").val(member.born_on);

      Object.assign(this.selectedMember, member);

      if (this.selectedMember.domicile_city) {
        this.domicile = true;
      } else {
        this.domicile = false;
      }

      this.updating_member = true;
        this.member_position = position;
    },
    projectHasMaster() {
      var bool = false;

      if (this.selectedMember.project_master == 1) {
        return bool;
      }

      this.members.forEach(function (member) {
        if (member.project_master == 1) {
          bool = true;
        }
      });

      return bool;
    },
      removeModal(member) {
        if (member != undefined)
            this.selectedMember = member;
      $("#remove_member_modal").modal();
    },
    removeMember() {
      var self = this;
        console.log(self.selectedMember);
      if (self.selectedMember.id) {
        axios
          .post(self.deleteRoute, {
            member: self.selectedMember,
          })
          .then((response) => {
            self.members.forEach(function (member) {
              if (member.id == self.selectedMember.id) {
                let index = self.members.indexOf(member);
                self.members.splice(index, 1);
              }
            });
          });
      } else {
        self.members.forEach(function (member) {
          if (JSON.stringify(member) === JSON.stringify(self.selectedMember)) {
            let index = self.members.indexOf(member);
            self.members.splice(index, 1);
          }
        });
      }

      this.show_team_list = true;
      this.member_position = this.members.length;
      this.updating_member = false;

      $("#remove_member_modal").modal("hide");
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.hover-mouse-pointer:hover {
  cursor: pointer;
}
</style>
